import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "overflow-hidden text-gray-700" }
const _hoisted_2 = { class: "container px-5 py-2 mx-auto lg:pt-12 lg:px-32" }
const _hoisted_3 = { class: "text-xl font-boldw" }
const _hoisted_4 = { class: "flex flex-wrap -m-1 md:-m-2" }
const _hoisted_5 = { class: "w-full p-1 md:p-2" }
const _hoisted_6 = ["src"]

import { reactive, ref } from "vue";
import { HoodApi } from "@/services/HoodApi";

export default /*#__PURE__*/_defineComponent({
  props: {
  tag: {
    type: String,
    required: true,
  },
},
  setup(__props) {

const props = __props

const photos = ref([]);


const init = async () => {
  console.log(props.tag);
  try {
    const response = await HoodApi.get_photos_by_tag(props.tag);
    console.log("This is the response from the api ");
    console.log(response);
    photos.value = response;
  } catch (e) {
    console.log(e);
  }
};

init();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h1", _hoisted_3, "#" + _toDisplayString(__props.tag), 1),
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(photos.value, (photo) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "flex flex-wrap w-1/3",
            key: photo.id
          }, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("img", {
                alt: "gallery",
                class: "block object-cover object-center w-full h-full rounded-lg",
                src: photo.file
              }, null, 8, _hoisted_6)
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(photo.hash_tag, (tag) => {
              return (_openBlock(), _createElementBlock("p", {
                key: tag.id,
                class: "mr-4"
              }, " #" + _toDisplayString(tag.text), 1))
            }), 128))
          ]))
        }), 128))
      ])
    ])
  ]))
}
}

})